import {FEATURE_REQUEST_ROLES} from 'functions/src/const/userRoles';

export const USER_ROLES = {
  ADD_APP: 'app:add',
  EDIT_APP: 'app:edit',
  DELETE_APP: 'app:delete',
  VIEW_APP: 'app:view',
  ADD_USER: 'user:add',
  EDIT_USER: 'user:edit',
  DELETE_USER: 'user:delete',
  VIEW_USER: 'user:view',
  ADD_TEAM: 'team:add',
  EDIT_TEAM: 'team:edit',
  DELETE_TEAM: 'team:delete',
};

export const STATS_ROLES = {
  VIEW_STATS: 'stats:view',
  EXPORT_STATS_TO_NOTION: 'stats:make-report-to-notion:get',
  VIEW_STATS_TEMPLATE: 'stats:report-template-monthly:view',
  UPDATE_STATS_TEMPLATE: 'stats:report-template-monthly:update',
};

export const NOTION_REPORT_TEMPLATE_ROLES = {
  VIEW_TEMPLATE: 'template:notion:view',
  UPDATE_TEMPLATE: 'template:notion:update',
  DELETE_TEMPLATE: 'template:notion:delete',
  ADD_TEMPLATE: 'template:notion:add',
};

export const TEAM_ROLES = {
  VIEW_TEAM: 'team:view',
  ADD_TEAM: 'team:add',
  EDIT_TEAM: 'team:edit',
  DELETE_TEAM: 'team:delete',
};

export const TRAFFIC_ROLES = {
  VIEW_TRAFFIC: 'traffic:view',
  ADD_PARTNER: 'partner:add',
  EDIT_PARTNER: 'partner:edit',
  DELETE_PARTNER: 'partner:delete',
};

export const SALE_ROLES = {
  VIEW_POTENTIAL_CUSTOMERS: 'sale:potential-customers:view',
};

export const ROLE_LABELS = {
  [FEATURE_REQUEST_ROLES.EDIT_FEATURE_REQUEST]: 'Change status of feature requests',
  [FEATURE_REQUEST_ROLES.ADD_FEATURE_REQUEST]: 'Add feature request',
  [FEATURE_REQUEST_ROLES.DELETE_FEATURE_REQUEST]: 'Delete feature request',
  [FEATURE_REQUEST_ROLES.BLOCK_USERS_FEATURE_REQUEST]: 'Block users from requesting features',
  [FEATURE_REQUEST_ROLES.DELETE_COMMENT_FEATURE_REQUEST]: 'Delete comment feature requests',
  [STATS_ROLES.VIEW_STATS]: 'View Stats',
  [STATS_ROLES.EXPORT_STATS_TO_NOTION]: 'Export Stats to Notion',
  [STATS_ROLES.VIEW_STATS_TEMPLATE]: 'View Monthly Stats Report Template',
  [STATS_ROLES.UPDATE_STATS_TEMPLATE]: 'Update Monthly Stats Report Template',
  [NOTION_REPORT_TEMPLATE_ROLES.VIEW_TEMPLATE]: 'View Notion Report Template',
  [NOTION_REPORT_TEMPLATE_ROLES.UPDATE_TEMPLATE]: 'Update Notion Report Template',
  [NOTION_REPORT_TEMPLATE_ROLES.DELETE_TEMPLATE]: 'Delete Notion Report Template',
  [NOTION_REPORT_TEMPLATE_ROLES.ADD_TEMPLATE]: 'Add Notion Report Template',
  [USER_ROLES.ADD_APP]: 'Add App',
  [USER_ROLES.EDIT_APP]: 'Edit App',
  [USER_ROLES.DELETE_APP]: 'Delete App',
  [USER_ROLES.VIEW_APP]: 'View App',
  [USER_ROLES.ADD_USER]: 'Add User',
  [USER_ROLES.EDIT_USER]: 'Edit User',
  [USER_ROLES.DELETE_USER]: 'Delete User',
  [USER_ROLES.VIEW_USER]: 'View User',
  [TEAM_ROLES.VIEW_TEAM]: 'View Team',
  [TEAM_ROLES.ADD_TEAM]: 'Add Team',
  [TEAM_ROLES.EDIT_TEAM]: 'Edit Team',
  [TEAM_ROLES.DELETE_TEAM]: 'Delete Team',
  [TRAFFIC_ROLES.VIEW_TRAFFIC]: 'View Traffic',
  [TRAFFIC_ROLES.ADD_PARTNER]: 'Add Partner',
  [TRAFFIC_ROLES.EDIT_PARTNER]: 'Edit Partner',
  [TRAFFIC_ROLES.DELETE_PARTNER]: 'Delete Partner',
  [SALE_ROLES.VIEW_POTENTIAL_CUSTOMERS]: 'View Potential Customers',
};

export const MEMBER_ROLE_TYPES = {
  BAS: 'bas',
  PMS: 'pms',
  TECH_LEADS: 'techLeads',
  DEVS: 'devs',
};

export const MEMBER_ROLE_LABELS = {
  [MEMBER_ROLE_TYPES.BAS]: 'Business Analyst',
  [MEMBER_ROLE_TYPES.PMS]: 'Product Manager',
  [MEMBER_ROLE_TYPES.TECH_LEADS]: 'Tech Lead',
  [MEMBER_ROLE_TYPES.DEVS]: 'Developer',
};

export const ALL_ROLES = [
  ...Object.values(USER_ROLES),
  ...Object.values(STATS_ROLES),
  ...Object.values(NOTION_REPORT_TEMPLATE_ROLES),
];

export const ROLE_CATEGORIES = {
  FEATURE_REQUEST: [...Object.values(FEATURE_REQUEST_ROLES)],
  STATS: [STATS_ROLES.VIEW_STATS, ...Object.values(STATS_ROLES)],
  NOTION_REPORT_TEMPLATE: [...Object.values(NOTION_REPORT_TEMPLATE_ROLES)],
  APP: [USER_ROLES.ADD_APP, USER_ROLES.EDIT_APP, USER_ROLES.DELETE_APP, USER_ROLES.VIEW_APP],
  USER: [USER_ROLES.ADD_USER, USER_ROLES.EDIT_USER, USER_ROLES.DELETE_USER, USER_ROLES.VIEW_USER],
  TRAFFIC: [
    TRAFFIC_ROLES.VIEW_TRAFFIC,
    TRAFFIC_ROLES.ADD_PARTNER,
    TRAFFIC_ROLES.EDIT_PARTNER,
    TRAFFIC_ROLES.DELETE_PARTNER,
  ],
  TEAM: [TEAM_ROLES.ADD_TEAM, TEAM_ROLES.EDIT_TEAM, TEAM_ROLES.DELETE_TEAM, TEAM_ROLES.VIEW_TEAM],
  SALE: [SALE_ROLES.VIEW_POTENTIAL_CUSTOMERS],
};
